export const parseBannersFromHtml = (htmlContent) => {
  const banners = [];
  const regex =
    /<div class="m-cross-fade-unit" id="([^"]+)" data-index="(\d+)">\s*<a href="([^"]+)"[^>]*>\s*<img src="([^"]+)"[^>]* alt="([^"]+)">/g;

  let match;
  while ((match = regex.exec(htmlContent)) !== null) {
    banners.push({
      id: match[1],
      index: parseInt(match[2]),
      href: match[3],
      src: match[4],
      alt: match[5],
    });
  }

  return banners;
};

export const generateBannerHtml = (banners, debugFlg) => {
  const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");

  return `<!DOCTYPE html>
<html lang="ja">
<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="author" content="">
    <meta name="description" content="">
    <meta name="keywords" content="jankatsu">
    <title>sp app home banners</title>
    
    <!-- 外部スクリプトの読み込み -->
    <script type="text/javascript" src="files/jquery-latest.js?202601251755"></script>
    <script type="text/javascript" src="files/jquery-migrate-latest.js?202601251755"></script>
    <script type="text/javascript" src="files/swipe2.js?202601251755"></script>
    <script type="text/javascript" src="files/swipe3_slider.js?202601251755"></script>
    
    <script type="text/javascript">
    var $mcp = jQuery.noConflict();

    // デバッグモード
    var DEBUG = ${debugFlg};
    function debugLog(message) {
        if (DEBUG) console.log('BANNER-DEBUG:', message);
    }

    // 環境設定（三項演算子を使用）
    var p_domain = DEBUG ? "jankatsu-dev.ztt.co.jp" : "jankatsu.ztt.co.jp";
    var p_port = DEBUG ? "v6" : "v7";
    var pre_url = "https://" + p_domain + "/" + p_port;
    var url = pre_url + "/api/registerADDisplayLog";

    // デバイス情報検出
    function detectDeviceInfo() {
        const ua = navigator.userAgent;
        let device = "unknown";
        let os = "unknown";

        if (/iPhone|iPad|iPod/.test(ua)) {
            device = "iOS Device";
            const match = ua.match(/OS (\\d+)_/);
            os = match ? "iOS " + match[1] : "iOS";
        } else if (/Android/.test(ua)) {
            device = "Android Device";
            const match = ua.match(/Android (\\d+(\\.\\d+)?)/);
            os = match ? "Android " + match[1] : "Android";
        } else if (/Windows/.test(ua)) {
            device = "PC";
            os = "Windows";
        } else if (/Macintosh/.test(ua)) {
            device = "PC";
            os = "macOS";
        }

        return { device, os };
    }

    // クエリパラメータ取得
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    let device = getQueryParam("device") || "unknown";
    let os = getQueryParam("os") || "unknown";

    if(device === "unknown" || os === "unknown") {
        const info = detectDeviceInfo();
        if(device === "unknown") device = info.device;
        if(os === "unknown") os = info.os;
    }

    const appVersion = getQueryParam("appVersion") || "unknown";
    const userId = getQueryParam("userId") || "unknown";

    // API呼び出し関数
    function callAPI(bannerId, eventKbn) {
        debugLog(\`API呼び出し: \${bannerId}, \${eventKbn}\`);
        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                bannerId: bannerId.split("-")[0],
                userId: userId,
                device: device,
                os: os,
                appVersion: appVersion,
                displayedAt: '${today}',
                eventKbn: eventKbn
            })
        }).catch(err => console.error("ログ送信失敗:", err));
    }

    // クリックログ記録
    function setupClickLogging() {
        debugLog('クリックログ設定開始');
        $mcp(document).off('click.adLog').on('click.adLog', '.m-cross-fade-unit a', function(e) {
            var $banner = $mcp(this).closest('.m-cross-fade-unit');
            var bannerId = $banner.attr('id');
            if (bannerId) {
                callAPI(bannerId, '1');
                debugLog(\`クリックログ: \${bannerId}\`);
            }
        });
        
        $mcp(document)
          .off('click.controllerLog')
          .on('click.controllerLog', '.cross-fade-controller a', function(e) {

            // 自動クリックを除外
            if (!e.isTrusted) {
                debugLog('自動クリック除外（controller）');
                return;
            }

            var index = $mcp(this).closest('li').index();
            var $banner = $mcp('.m-cross-fade-unit').eq(index);
            var bannerId = $banner.attr('id');

            if (bannerId) {
                callAPI(bannerId, '1');
                debugLog(\`手動コントローラーークリック: \${bannerId}\`);
            }
        });

    }

    // Intersection Observerの設定
    function setupIntersectionObserver() {
        const banners = document.querySelectorAll('.m-cross-fade-unit');
        if (banners.length === 0) return;

        // 表示中かどうかだけ管理
        const visibleMap = new WeakMap();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const banner = entry.target;
                const bannerId = banner.id || banner.dataset.index;
                if (!bannerId) return;

                const wasVisible = visibleMap.get(banner) || false;

                // 非表示 → 表示 に変わった瞬間だけ送信
                if (entry.isIntersecting && !wasVisible) {
                    callAPI(bannerId, '0');
                    debugLog(\`表示ログ（再計数）: \${bannerId}\`);
                    visibleMap.set(banner, true);
                }

                // 表示 → 非表示
                if (!entry.isIntersecting && wasVisible) {
                    visibleMap.set(banner, false);
                }
            });
        }, {
            threshold: 0.3,
            rootMargin: '50px'
        });

        banners.forEach(banner => {
            visibleMap.set(banner, false);
            observer.observe(banner);
        });
    }


    // 改良したシャッフル関数（mcpSliderとの互換性を考慮）
    function shuffleBanners() {
        debugLog('シャッフル開始');
        var $bannerList = $mcp('#rt_app_banners');
        var $banners = $bannerList.find('.m-cross-fade-unit');
        
        if ($banners.length < 2) {
            debugLog('シャッフル不要: バナー数が1以下');
            return;
        }
        
        // 元の順序を保存
        var originalOrder = $banners.toArray();
        
        // シャッフルされた順序を生成
        var shuffledOrder = [...originalOrder];
        for (var i = shuffledOrder.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            [shuffledOrder[i], shuffledOrder[j]] = [shuffledOrder[j], shuffledOrder[i]];
        }
        
        // コントローラーも同じ順序でシャッフル
        var $controller = $mcp('.cross-fade-controller');
        var $controllerItems = $controller.find('li');
        
        if ($controllerItems.length === $banners.length) {
            var controllerArray = $controllerItems.toArray();
            var controllerShuffled = [...controllerArray];
            
            // バナーと同じシャッフル順序を適用
            for (var k = controllerShuffled.length - 1; k > 0; k--) {
                var l = Math.floor(Math.random() * (k + 1));
                [controllerShuffled[k], controllerShuffled[l]] = [controllerShuffled[l], controllerShuffled[k]];
            }
            
            $controller.empty().append(controllerShuffled);
            debugLog('コントローラーもシャッフル完了');
        }
        
        // DOMを更新
        $bannerList.empty().append(shuffledOrder);
        
        // data-index属性を更新
        $bannerList.find('.m-cross-fade-unit').each(function(index) {
            $mcp(this).attr('data-index', index);
        });
        
        debugLog(\`シャッフル完了: \${$banners.length}個のバナー\`);
        return shuffledOrder;
    }

    // mcpSliderを安全に初期化
    function initMcpSlider() {
        debugLog('mcpSlider初期化開始');
        
        if (typeof mcpSlider !== 'function') {
            debugLog('エラー: mcpSlider関数が見つかりません');
            return false;
        }
        
        try {
            // スライダーを初期化
            var slider = mcpSlider({
                "tag": ".info-bnr .cross-fade-block",
                "parent": ".m-cross-fade-group",
                "child": ".m-cross-fade-unit"
            });
            
            debugLog('mcpSlider初期化成功');
            
            // スライダーオブジェクトをグローバルに保存（必要であれば）
            window.currentSlider = slider;
            
            return true;
        } catch (error) {
            debugLog('mcpSlider初期化エラー: ' + error.message);
            return false;
        }
    }

    // ランダムなスライドから開始
    function startFromRandomPosition() {
        var $banners = $mcp('.m-cross-fade-unit');
        if ($banners.length === 0) return;
        
        var randomIndex = Math.floor(Math.random() * $banners.length);
        debugLog(\`ランダム開始位置: \${randomIndex}/\${$banners.length}\`);
        
        // mcpSliderのAPIを試す
        if (window.currentSlider && typeof window.currentSlider.goTo === 'function') {
            try {
                window.currentSlider.goTo(randomIndex);
                debugLog(\`mcpSlider.goTo(\${randomIndex})を実行\`);
            } catch (error) {
                debugLog('goToエラー: ' + error.message);
            }
        } else {
            // 代替方法：少し遅らせてコントロールーをクリック
            setTimeout(function() {
                var $controllerItems = $mcp('.cross-fade-controller li');
                if ($controllerItems.length > randomIndex) {
                    $controllerItems.eq(randomIndex).find('a').trigger('click');
                    debugLog(\`コントローラー経由で開始: \${randomIndex}\`);
                }
            }, 1000);
        }
    }

    // メイン初期化シーケンス
    function initializeApp() {
        debugLog('=== アプリ初期化開始 ===');
        
        // 1. クリックログ設定
        setupClickLogging();
        
        // 2. バナーをシャッフル
        shuffleBanners();
        
        // 3. mcpSliderを初期化
        if (initMcpSlider()) {
            // 4. ランダムな位置から開始
            setTimeout(function() {
                startFromRandomPosition();
            }, 500);
            
            // 5. Intersection Observerを設定（少し遅らせる）
            setTimeout(setupIntersectionObserver, 1000);
        } else {
            // mcpSliderが使えない場合
            debugLog('mcpSliderなしで継続');
            setupIntersectionObserver();
        }
        
        debugLog('=== アプリ初期化完了 ===');
    }

    // メイン実行
    $mcp(function() {
        debugLog('jQuery ready');
        
        // ページ全体の読み込みを待つ
        $mcp(window).on('load', function() {
            debugLog('window load イベント');
            setTimeout(initializeApp, 300);
        });
        
        // フォールバック：loadイベントが発火しない場合
        setTimeout(function() {
            if (!$mcp('.m-cross-fade-unit').length) {
                debugLog('loadイベントタイムアウト、強制初期化');
                initializeApp();
            }
        }, 5000);
    });

    // グローバルエラーハンドリング
    window.addEventListener('error', function(e) {
        console.error('グローバルエラー:', e.message, 'at', e.filename, ':', e.lineno);
    });
    </script>
    
    <style>
        div.info-bnr {
            padding: 4px 10px 10px 10px;
        }

        div.info-bnr .m-cross-fade-unit,
        div.info-bnr .m-cross-fade-unit img {
            width: 100%;
        }

        div.info-bnr .cross-fade-controller {
            display: none;
        }

        div.info-bnr div.cross-fade-block div.m-cross-fade-group {
            z-index: 0;
        }

        div.info-bnr {
            padding: 4px 10px;
        }

        div.info-bnr .cross-fade-block {
            overflow: hidden;
            visibility: hidden;
            position: relative;
        }

        div.info-bnr .m-cross-fade-group {
            overflow: hidden;
            position: relative;
            height: 0;
        }

        div.info-bnr .m-cross-fade-group > div {
            float: left;
            width: 100%;
            position: relative;
        }

        div.info-bnr .mcp_pos {
            display: block;
            text-align: center;
        }

        div.info-bnr .mcp_pos em {
            background: #666;
            text-indent: -9999px;
            display: inline-block;
            width: 10px;
            height: 10px;
            margin: 5px;
            outline: 0;
            -moz-border-radius: 5px;
            -webkit-border-radius: 5px;
            border-radius: 5px;
        }

        div.info-bnr .mcp_pos em.on {
            background: #903;
        }
        
        /* スライダー初期化用の基本スタイル */
        #rt_app_banners {
            position: relative;
        }
        
        .m-cross-fade-unit {
            position: absolute;
            top: 0;
            left: 0;
        }
    </style>
</head>
<body>

<div class="info-bnr">
    <div class="cross-fade-block">
        <div class="m-cross-fade-group slide-list" id="rt_app_banners">
            ${banners
              .map(
                (banner, idx) => `
            <div class="m-cross-fade-unit" id="${banner.id}" data-index="${idx}">
                <a href="${banner.href}" target="_blank">
                    <img src="${banner.src}" alt="${banner.alt}">
                </a>
            </div>`,
              )
              .join("")}
        </div>
        <ul class="cross-fade-controller">
            ${banners
              .map(
                (banner) => `
            <li><a href="${banner.href}">
                <img width="18" height="8" alt="" src="${banner.src}">
            </a></li>`,
              )
              .join("")}
        </ul>
    </div>
</div>

<iframe allow="join-ad-interest-group" data-tagging-id="AW-994868581" data-load-time="1708839030179" height="0"
        width="0" style="display: none; visibility: hidden;"
        src="files/994868581.html"></iframe>
<iframe allow="join-ad-interest-group" data-tagging-id="AW-947606755" data-load-time="1708839030259" height="0"
        width="0" style="display: none; visibility: hidden;"
        src="files/947606755.html"></iframe>
<iframe allow="join-ad-interest-group" data-tagging-id="AW-948979393" data-load-time="1708839030288" height="0"
        width="0" style="display: none; visibility: hidden;"
        src="files/948979393.html"></iframe>

</body>
</html>`;
};

// 小広告
export const parseSmallBannersFromHtml = (htmlContent) => {
  const banners = [];
  const regex =
    /{ id: "([^"]+)", href: "([^"]+)", img: "([^"]+)", alt: "([^"]+)" }/g;

  let match;
  const seen = new Set();
  while ((match = regex.exec(htmlContent)) !== null) {
    if (!seen.has(match[1])) {
      seen.add(match[1]);
      banners.push({
        id: match[1],
        href: match[2],
        src: match[3],
        alt: match[4],
      });
    }
  }

  return banners;
};

export const generateSmallBannerHtml = (banners, debugFlg) => {
  const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");

  return `<!DOCTYPE html>
<html lang="ja">
<head>
<meta charset="UTF-8" />
<title>banner2</title>

<script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>

<style>
 
.info-bnr {
  padding:0;
  text-align: center;
  user-select: none;
  margin-top: 0;
}

.thumbnail-list-container {
  overflow: hidden;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  position: relative;
  height: auto;
  max-height: 200px;
}

.thumbnail-list {
    display: flex;
    width: max-content;
    height: 100%;
    animation: scroll-right 75s linear infinite;
}

.thumbnail-list a {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  margin: 0 8px;
  overflow: hidden;
  width: clamp(90px, 18vw, 150px);
}

.thumbnail-list img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  display: block;
}

@keyframes scroll-right {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
}
</style>
</head>
<body>

<div class="info-bnr">
  <div class="thumbnail-list-container">
    <div class="thumbnail-list"></div>
  </div>
</div>

<script>
  function detectDeviceInfo() {
    const ua = navigator.userAgent;
    let device = "unknown";
    let os = "unknown";

    if (/iPhone|iPad|iPod/.test(ua)) {
      device = "iOS Device";
      const match = ua.match(/OS (\\d+)_/);
      if (match) {
        os = "iOS " + match[1];
      } else {
        os = "iOS";
      }
    } else if (/Android/.test(ua)) {
      device = "Android Device";
      const match = ua.match(/Android (\\d+(\\.\\d+)?)/);
      if (match) {
        os = "Android " + match[1];
      } else {
        os = "Android";
      }
    } else if (/Windows/.test(ua)) {
      device = "PC";
      os = "Windows";
    } else if (/Macintosh/.test(ua)) {
      device = "PC";
      os = "macOS";
    }

    return { device, os };
  }

  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  
  let device = getQueryParam("device") || "unknown";
  let os = getQueryParam("os") || "unknown";
  
  if(device === "unknown" || os === "unknown") {
    const info = detectDeviceInfo();
    console.log(info.device, info.os);
    if(device === "unknown") {
      device = info.device;
    }
    if(os == "unknown") {
      os = info.os;
    }
  }
  const appVersion = getQueryParam("appVersion") || "unknown";
  const userId = getQueryParam("userId") || "unknown";

  function logAdClick(bannerId) {
    callAPI(bannerId, '1')
  }

   function logAdAuto(bannerId) {
    callAPI(bannerId, '0')
  }

  function callAPI(bannerId, eventKbn) {
    // デバッグモード
    var DEBUG = ${debugFlg};
    // 環境設定（三項演算子を使用）
    var p_domain = DEBUG ? "jankatsu-dev.ztt.co.jp" : "jankatsu.ztt.co.jp";
    var p_port = DEBUG ? "v6" : "v7";
    var pre_url = "https://" + p_domain + "/" + p_port;
    var url = pre_url + "/api/registerADDisplayLog";

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        bannerId: bannerId.split("-")[0],
        userId: userId,
        device: device,
        os: os,
        appVersion: appVersion,
        displayedAt: '${today}',
        eventKbn: eventKbn
      })
    }).catch(err => console.error("ログ送信失敗:", err));
  }

  function checkVisibility() {
    $('.thumbnail-list a').each(function() {
      const rect = this.getBoundingClientRect();
      const inView = rect.left < window.innerWidth && rect.right > 0;
      if (inView && !sentLog.has(this)) {
        const bannerId = $(this).data('banner-id');
        if (bannerId) {
          logAdAuto(bannerId);
          sentLog.add(this);
        }
      }
    });
    requestAnimationFrame(checkVisibility);
  }

  $('.thumbnail-list').on('click', '.thumb', function() {
    $('.thumbnail-list').css('animation-play-state', 'running');
  });
  
  function shuffleArray(array) {
    return array.sort(() => Math.random() - 0.5);
  }

  const sentLog = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(entry.isIntersecting && !sentLog.has(entry.target)) {
      const bannerId = entry.target.dataset.bannerId;
        if(bannerId) {
          logAdAuto(bannerId);
          sentLog.add(entry.target);
        }
      }
    });
  }, { threshold: 0});

  $(function() {
    const banners = [
${banners.map((banner, idx) => `     { id: "${banner.id}", href: "${banner.href}", img: "${banner.src}", alt: "${banner.alt}" }`).join(",\n")}
    ];

    const shuffled = shuffleArray(banners);
    const thumbnails = shuffled.concat(shuffled);
    thumbnails.forEach((banner) => {
      const $a = $(
      \`<a href="\${banner.href}" 
         target="_blank" 
         draggable="false" 
         onclick="logAdClick('\${banner.id}')"
         data-banner-id="\${banner.id}">
        <img src="\${banner.img}" alt="\${banner.alt}" draggable="false" />
      </a>\`
    );

    $('.thumbnail-list').append($a);
    observer.observe($a[0]);
    });
    checkVisibility();
  });
</script>

</body>
</html>`;
};
